import { BankDetailsRequest, BankDetailsResponseModel, BankIdReq, CompanyReq } from "@gtpl/shared-models/masters";
import { connection } from "..";
import axios from "axios";
import { CommonResponse } from "@gtpl/shared-models/production-management";

export class BankDetailsService {
    
      URL = connection.DEPLOY_URL + '/bank-details';
    
      async createBankDetails(req:BankDetailsRequest): Promise<BankDetailsResponseModel> {
        return await axios.post(this.URL + '/createBankDetails', req)
          .then(res => {
            return res.data
          })
      }
      async getAllBankDetailsInfo(): Promise<BankDetailsResponseModel> {
        return await axios.post(this.URL + '/getAllBankDetailsInfo')
          .then(res => {
            return res.data
          })
      }
      async updateBankDetails(req:BankDetailsRequest): Promise<BankDetailsResponseModel> {
        return await axios.post(this.URL + '/updateBankDetails',req)
            .then(res => {
                return res.data
            }) 
    }
    async activatedeActivate(
        Dto: BankDetailsRequest
      ): Promise<BankDetailsResponseModel> {
        //   console.log(State.stateCode);
        return await axios
          .post(this.URL + '/activateOrDeactivateBankDetails', Dto)
          .then((res) => {
            return res.data;
          });
      }

  async getBankDetailsByCompany(req:CompanyReq): Promise<CommonResponse> {
    return await axios.post(this.URL + '/getBankDetailsByCompany',req)
        .then(res => {
            return res.data
    }) 
  }
  async getBankDetailsById(req:BankIdReq): Promise<CommonResponse> {
    return await axios.post(this.URL + '/getBankDetailsById',req)
        .then(res => {
            return res.data
    }) 
  }
}